import React, { useState, useEffect } from "react";
import { Button, Input, Loading, Text } from "@nextui-org/react";
import { useSelector } from "react-redux";
import { mstore } from "../../store";
import endpoint from "../../config/endpoint.json";
import { success, error } from "../../lib/userAlerts";
import { secureFetch } from "../../lib/api";

const GPSInterval = () => {
  const [state, setState] = useState({
    range: 0,
    pingInterval: 0,
    updating: false
  });

  const Access = useSelector(state => state.navigation.Access);
  const clientId = useSelector(state => 
    state.client?.id || mstore.getPath(["user", "company_id"])
  );

  const fetchGeofenceRange = async () => {
    try {
      const [ok, , json] = await secureFetch(endpoint.fetchGeofenceRange, {});
      if (ok) {
        setState(prev => ({ 
          ...prev, 
          range: json.geofanceRange[0].geofence_range 
        }));
      } else {
        error("Oops! error occurred during fetch geofence range for this company");
      }
    } catch (err) {
      error("Oops! error occurred during fetch geofence range for this company");
    }
  };

  const fetchPingInterval = async () => {
    try {
      const [ok, , json] = await secureFetch(endpoint.fetchPingInterval, {});
      if (ok) {
        setState(prev => ({
          ...prev,
          pingInterval: json.pingInterval[0].gps_refresh_interval
        }));
      } else {
        error("Oops! error occurred during fetch geofence range for this company");
      }
    } catch (err) {
      error("Oops! error occurred during fetch geofence range for this company");
    }
  };

  const saveGeofenceRange = async () => {
    if (state.range < 0 || state.range > 20) {
      error("Geo fence range should be between 0 and 20 miles");
      return;
    }

    setState(prev => ({ ...prev, updating: true }));
    try {
      const [ok, , json] = await secureFetch(endpoint.saveGeofenceRange, {
        range: state.range,
      });
      
      if (ok) {
        success(json.message);
        await fetchGeofenceRange();
      } else {
        error("Oops! error occurred during save geofence range for this company");
      }
    } catch (err) {
      error("Oops! error occurred during save geofence range for this company");
    } finally {
      setState(prev => ({ ...prev, updating: false }));
    }
  };

  const savePingInterval = async () => {
    if (10 > state.pingInterval || state.pingInterval > 300) {
      error("GPS ping interval should be greater than 10 seconds and less than 300 seconds");
      return;
    }

    try {
      const [ok, , json] = await secureFetch(endpoint.savePingInterval, {
        pingInterval: state.pingInterval,
      });
      
      if (ok) {
        success(json.message);
        await fetchPingInterval();
      } else {
        error("Oops! error occurred during save geofence range for this company");
      }
    } catch (err) {
      error("Oops! error occurred during save geofence range for this company");
    }
  };

  useEffect(() => {
    fetchGeofenceRange();
    fetchPingInterval();
  }, [clientId]);

  if (Access.allow_location_info !== 1) {
    return (
      <div role="alert" className="alert alert-warning w-1/2 mt-16">
        <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="white" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span className="">Please subscribe to the <b>Location Information</b> feature</span>
      </div>
    );
  }

  return (
    <div className="w-100 flex flex-row">
      <div className="ml2 mt3 w-1/2 p-4 border-2 border-dotted rounded-xl shadow-lg">
        <div className="f4 mb3"><h2 className="text-xl font-semibold text-gray-800">GPS Range</h2></div>
        <div className="flex flex-row justify-between items-center">
          <div className="f5">Geofence range in miles</div>
          <Input
            type='number'
            underlined
            css={{ width: '120px' }}
            min={0}
            max={20}
            defaultValue={0}
            value={state.range}
            onChange={(e) => setState(prev => ({ ...prev, range: e.target.value }))}
          />
        </div>
        <div className="flex justify-end pt-6">
          <Button
            auto
            color="primary"
            className="hover:bg-blue-600 transition-colors duration-200"
            onClick={saveGeofenceRange}
          >
            <Text color="white">Update Interval</Text>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GPSInterval;